import React, { useMemo, useCallback } from 'react'
import customerOrderRefundItemTableColumns from 'domains/customer-order/molecules/refund-item-table-columns'
import DataTableStatic from 'components/organisms/data-table-static'
import PropTypes from 'prop-types'

const propTypes = {
  data             : PropTypes.array,
  setRefundItems   : PropTypes.func,
  setSelectedItem  : PropTypes.func,
  setIsModalOpen   : PropTypes.func,
  handleSubmitForm : PropTypes.func
}

const defaultProps = {
  data             : [],
  setRefundItems   : () => {},
  setSelectedItem  : () => {},
  setIsModalOpen   : () => {},
  handleSubmitForm : () => {}
}

/**
 * @param {Array<Object>} data - array of order items objects that will be refunded
 * @param {func} setRefundItems - function for set selected item to refundItems state
 * @param {func} setSelectedItem - function for set selected item to selectedItem state
 * @param {func} setIsModalOpen - function for set IsModalOpen state
 * @param {func} handleSubmitForm - function for submit form
 */
const CustomerOrderRefundItemListTable = ({
  data,
  setRefundItems,
  setSelectedItem,
  setIsModalOpen,
  handleSubmitForm
}) => {

  const handleClickEdit = useCallback( (item) => {
    setSelectedItem(item)
    setIsModalOpen(true)
  }, [ setSelectedItem, setIsModalOpen ])

  const handleClickDelete = useCallback( (item) => {
    const updatedRefundItems =  data.filter((element) => element.sku !== item.sku)
    setRefundItems(updatedRefundItems)
  }, [ data, setRefundItems ])

  /**
   * It's important that we're using React.useMemo
   * here to ensure that our data isn't recreated on every render.
   * see https://react-table.tanstack.com/docs/quick-start
   *  */
  const columns = useMemo(() => customerOrderRefundItemTableColumns({ handleClickEdit, handleClickDelete, handleSubmitForm }), [ handleClickEdit, handleClickDelete, handleSubmitForm ])

  return (
    <DataTableStatic
      data={ data }
      columns={ columns }
    />
  )
}

CustomerOrderRefundItemListTable.propTypes    = propTypes
CustomerOrderRefundItemListTable.defaultProps = defaultProps

export default CustomerOrderRefundItemListTable
